export var TournamentType;
(function (TournamentType) {
    TournamentType["RoundRobin"] = "RoundRobin";
})(TournamentType || (TournamentType = {}));
